import { render, staticRenderFns } from "./ModalSuccess.vue?vue&type=template&id=4d06d813&scoped=true"
import script from "./ModalSuccess.vue?vue&type=script&lang=js"
export * from "./ModalSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d06d813",
  null
  
)

export default component.exports